<template>
  <div class="">
    <h3 class="font-size-xl wc-loyalty__name" id="progress-bar-label">
      {{ loyalty.name }}
    </h3>
    <div class="d-flex font-size-lg pt-2 wc-loyalty__balance">
      <span class="w-50 wc-loyalty__balance-text" v-if="loyalty.showDecimal">
        {{ $t('balance') }}: {{ current | currency }}
      </span>
      <span class="w-50 wc-loyalty__balance-text" v-if="!loyalty.showDecimal">
        {{ $t('balance') }}: {{ current }} {{ $t('points') }}
      </span>
      <span
        class="w-50 text-right wc-loyalty__balance-text"
        v-if="current < max && loyalty.showDecimal"
        >{{ $t('redeemAt') }} {{ max | currency }}</span
      >
      <span
        class="w-50 text-right wc-loyalty__balance-text"
        v-if="current < max && !loyalty.showDecimal"
        >{{ $t('redeemAt') }} {{ max }} {{ $t('points') }}</span
      >
      <span class="w-50 text-right wc-loyalty__balance-text" v-if="current > 0 && current >= max">
        {{ $t('readyToRedeem') }}
      </span>
    </div>
    <WCProgressBar class="my-1" v-if="max" :current="current" :max="max" size="large" />
  </div>
</template>

<script>
import WCProgressBar from '@/components/WCProgressBar/WCProgressBar.vue';

export default {
  name: 'WCLoyalty',
  components: {
    WCProgressBar,
  },
  props: {
    loyalty: {
      type: Object,
      required: true,
    },
  },
  computed: {
    current() {
      return this.loyalty.showDecimal ? this.loyalty.balance : 100 * this.loyalty.balance;
    },
    max() {
      const amount = Math.max(this.loyalty.minimumBalance, this.loyalty.minimumRedemption);
      return this.loyalty.showDecimal ? amount : amount * 100;
    },
  },
};
</script>

<style scoped></style>
